import { render, staticRenderFns } from "./creationList.vue?vue&type=template&id=285cf08e&scoped=true"
import script from "./creationList.vue?vue&type=script&lang=js"
export * from "./creationList.vue?vue&type=script&lang=js"
import style0 from "./creationList.vue?vue&type=style&index=0&id=285cf08e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "285cf08e",
  null
  
)

export default component.exports